import {
  isArray, isEqual, isObject, transform,
} from 'lodash';
import { TPersonnel } from '../../types';

type TBaseObj = { [key: string]: any };

const sortByOnlineMember = <
  const T extends { email?: string } & { personnel?: TPersonnel },
>(
    items: Array<T>,
    email: string,
  ): Array<T> => {
  const sortItem = items.splice(
    items.findIndex((item) => (item.personnel?.email || item?.email) === email),
    1,
  );

  return [...sortItem, ...items];
};

const getDiffBetweenNestedObj = <T>(
  obj: TBaseObj,
  baseObj: TBaseObj,
  fieldToSkip?: string,
) => {
  function changes(object: TBaseObj, base: TBaseObj) {
    let arrayIndexCounter = 0;
    return transform(
      object,
      (result: TBaseObj, value: ReadonlyArray<T> | T, key: string | number) => {
        if (key !== fieldToSkip && !isEqual(value, base[key])) {
          const resultKey = isArray(base) ? arrayIndexCounter += 1 : key;

          // eslint-disable-next-line no-param-reassign
          result[resultKey] = isObject(value) && isObject(base[key])
            ? changes(value, base[key])
            : value;
        }
      },
    );
  }
  return changes(obj, baseObj);
};

const draggableReorder = <T>(list: Array<T>, startIndex: number, endIndex: number) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export {
  getDiffBetweenNestedObj,
  sortByOnlineMember,
  draggableReorder,
};
